import Ob1Component from "./ob1-component";

// la liste des classes utiles dans le code du composant
const classes = {
  active: "ob1-filterchip-button-active"
};

// la liste des sélecteurs que l'on utilise dans le code du composant
const selector = {
  button: "button"
};

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */
class Chips extends Ob1Component {

  constructor(container, parameters) {
    super(container, "Chips", parameters);
  }

  /**
   * Initialisation du composant
   *
   * @param {HTMLElement} container le noeud DOM sur lequel est instancié le composant
   * @param {object} parameters les paramètres de ce composant
   */
  init(container, parameters) {

    // on appelle la méthode d'initialisation d'Ob1Component (obligatoire)
    super.init(container, parameters);


    this.buttonList = this.container.querySelectorAll(selector.button);

    // chaque button doit avoir un attribut aria-pressed
    // pour garantir l'accessibilité, on l'ajoute si absent
    this._addAriaPressedAttributeIfMissing();
    this._addEvents();
  }

  /**
   * Gestion des événements sur le composant
   * @private
   */
  _addAriaPressedAttributeIfMissing() {
      this.buttonList.forEach((button) => {
        if (button.getAttribute("aria-pressed") === null) {
          button.setAttribute("aria-pressed", button.classList.contains(classes.active));
        }
      });
  }

  /**
   * Gestion des événements sur le composant
   * @private
   */
  _addEvents() {
    this._onClick = (event) => {
      this.buttonList.forEach((button) => {
        if (button === event.target) {
          button.classList.toggle(classes.active);
          button.setAttribute("aria-pressed", button.classList.contains(classes.active));
        }
      });

    };
    this.container.addEventListener("click", this._onClick);
  }

  /**
   * Décharge le composant
   */
  dispose () {

    // suppression de tous les event listeners qui ont été créés
    this.container.removeEventListener("click", this._onClick);

    // on appelle la méthode de suppression de composant d'Ob1Component (obligatoire)
    super.dispose();
  }
}

// rattachement au contexte window pour pouvoir l'utiliser en dehors du JS
window.Chips = Chips;

export default Chips;
